import {
  SUCCESS_API_GET_COMPANY_TAG_SET,
  SET_TAGS_FOR_LEVEL,
  SET_SELECTED_TAG_SET,
  SET_SELECTED_TAG,
  OPEN_ONE_LAYER_MASTER_IMPORT_DIALOG,
  CLOSE_ONE_LAYER_MASTER_IMPORT_DIALOG,
  SHOW_UNAVAILABLE_TAGS,
  HIDE_UNAVAILABLE_TAGS,
} from '../actions/actionTypes';

export const appInitialState = {
  uploadFile: {},
  maxDepth: 2,
  // 企業に紐づく全てのタグセットを格納
  companyAssociatedTagSets: [],
  // 表に表示する各階層のタグ配列。選択した親階層のタグに紐づくタグを格納する。
  tags: {
    level1: [],
    level2: [],
    level3: [],
    level4: [],
    level5: [],
  },
  // 現在選択しているタグ
  selectedTag: {
    depth: null,
    id: null,
    name: null,
    parentId: null,
    isUsable: null,
  },
  // 現在選択しているタグセットのID
  selectedTagSetId: '',
  // 選択済みのタグの配列。第1階層のタグはselectedTagIds[0]に入るので注意
  selectedTagIds: [],
  openEditMasterDialog: 'none',
  openOneLayerMasterImportDialog: false,
  openMasterImportDialog: false,
  // 利用不可状態のタグを表示するかどうか
  showUnavailableTags: false,
  showEditMasterDialogErrorMsg: false,
  notifyUpdate: new Date(), // 任意のコンポーネント更新に利用
  openImportErrorDialog: false,
  errorMessages: null,
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case 'SUCCESS_API_IMPORT_TAGS': {
      const uploadFile = {};
      return { ...state, uploadFile };
    }
    case 'SUCCESS_API_REIMPORT_TAGS': {
      const uploadFile = {};
      return { ...state, uploadFile };
    }
    case 'SELECT_IMPORT_CSV': {
      const uploadFile = action && action.uploadFile;
      return { ...state, uploadFile };
    }
    case 'OPEN_EDIT_MASTER_DIALOG': {
      const openEditMasterDialog = 'edit';
      const { selectedTag } = action;
      return { ...state, openEditMasterDialog, selectedTag };
    }
    case 'CLOSE_EDIT_MASTER_DIALOG': {
      const { openEditMasterDialog, showEditMasterDialogErrorMsg } =
        appInitialState;
      return { ...state, openEditMasterDialog, showEditMasterDialogErrorMsg };
    }
    case OPEN_ONE_LAYER_MASTER_IMPORT_DIALOG: {
      const openOneLayerMasterImportDialog = true;
      const { selectedTag } = action;
      return { ...state, openOneLayerMasterImportDialog, selectedTag };
    }
    case CLOSE_ONE_LAYER_MASTER_IMPORT_DIALOG: {
      const { openOneLayerMasterImportDialog } = appInitialState;
      return { ...state, openOneLayerMasterImportDialog };
    }
    case 'OPEN_MASTER_IMPORT_DIALOG': {
      return { ...state, openMasterImportDialog: true };
    }
    case 'CLOSE_MASTER_IMPORT_DIALOG': {
      return { ...state, openMasterImportDialog: false };
    }
    case 'SWITCH_SHOW_EDIT_MASTER_DIALOG_ERROR_MSG': {
      const showEditMasterDialogErrorMsg = true;
      return { ...state, showEditMasterDialogErrorMsg };
    }
    case 'SWITCH_SHOW_MODE_EDIT_MASTER_DIALOG': {
      const { nextShowMode } = action;
      let { openEditMasterDialog } = state;
      openEditMasterDialog = nextShowMode;
      return { ...state, openEditMasterDialog };
    }
    case 'OPEN_IMPORT_ERROR_DIALOG': {
      const { errorMessages } = action;
      return { ...state, openImportErrorDialog: true, errorMessages };
    }
    case 'CLOSE_IMPORT_ERROR_DIALOG': {
      return { ...state, openImportErrorDialog: false };
    }
    // 企業に紐づくタグセットをAPIから取得してstoreにセットする
    case SUCCESS_API_GET_COMPANY_TAG_SET: {
      const companyAssociatedTagSets =
        action.payload.length > 0 ? action.payload[0].data : [];
      return {
        ...state,
        companyAssociatedTagSets,
        maxDepth: action.maxDepth,
      };
    }
    // タグセットを選択
    case SET_SELECTED_TAG_SET: {
      return {
        ...state,
        selectedTagSetId: action.payload,
        tags: {
          level1: [],
          level2: [],
          level3: [],
          level4: [],
          level5: [],
        },
        selectedTagIds: [],
      };
    }
    // 各階層のタグをAPIから取得してtagsにセットする
    case SET_TAGS_FOR_LEVEL: {
      // 現在処理中の階層とデータ
      let currentDepth;
      let currentLevelData;
      if (action.payload.length > 0) {
        [{ depth: currentDepth, data: currentLevelData }] = action.payload;
      } else {
        currentDepth = action.depth;
        currentLevelData = [];
      }

      const updateTags = {
        ...state.tags,
        [`level${currentDepth}`]: currentLevelData,
      };
      // 現在の階層より上の階層を空配列でリセット
      for (let i = currentDepth + 1; i <= 5; i += 1) {
        updateTags[`level${i}`] = [];
      }
      return {
        ...state,
        tags: updateTags,
      };
    }
    // 選択したタグをselectTagIdsにセットする
    case SET_SELECTED_TAG: {
      const updatedSelectedTagIds = [...state.selectedTagIds];
      const selectedDepth = action.payload.depth;

      // 選択したタグの階層より上の階層を空配列でリセット
      updatedSelectedTagIds[selectedDepth - 1] = action.payload.id;
      for (let i = selectedDepth; i < state.maxDepth; i += 1) {
        updatedSelectedTagIds[i] = null;
      }
      return {
        ...state,
        selectedTagIds: updatedSelectedTagIds,
      };
    }
    case SHOW_UNAVAILABLE_TAGS: {
      return {
        ...state,
        showUnavailableTags: true,
      };
    }
    case HIDE_UNAVAILABLE_TAGS: {
      return {
        ...state,
        showUnavailableTags: false,
      };
    }
    // TODO: SET_TAGS_FOR_LEVELと共通部分あり。あとで直す
    case 'GET_UPDATE_TAGS': {
      let currentDepth;
      let currentLevelData;
      if (action.payload.length > 0) {
        [{ depth: currentDepth, data: currentLevelData }] = action.payload;
      } else {
        currentDepth = action.depth;
        currentLevelData = [];
      }
      const updateTags = {
        ...state.tags,
        [`level${currentDepth}`]: currentLevelData,
      };
      return {
        ...state,
        tags: updateTags,
      };
    }
    default:
      return state;
  }
};
